import { render, staticRenderFns } from "./UseShareTokenView.vue?vue&type=template&id=5d8d91e4&scoped=true"
import script from "./UseShareTokenView.vue?vue&type=script&lang=js"
export * from "./UseShareTokenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8d91e4",
  null
  
)

export default component.exports